import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { User } from '../../user/user';

@Injectable({
  providedIn: 'root',
})
export class RolesGuard implements CanActivate {
  private readonly UserService = inject(User);
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const userInfo = this.UserService.getUser();
    if (!userInfo) {
      this.router.navigate(['/login'], {
        queryParams: {
          reason: 'session_expired',
        },
      });

      return false;
    }
    const allowedRoles = route.data['roles'] as string[];

    if (!allowedRoles || allowedRoles.length === 0) {
      return true;
    }

    const { roles } = userInfo || {};
    console.log({ roles });
    const hasRole = allowedRoles.some((role) => roles.includes(role));

    if (hasRole) {
      return true;
    }
    console.log('Access denied - Insufficient role');
    this.router.navigate(['/login'], {
      queryParams: {
        reason: 'unauthorized',
      },
    });

    return false;
  }
}
